import * as React from 'react';
import AuditabilityDataFloat from './AuditabilityDataFloat';
import AuditabilityDataTimeSeries from './AuditabilityDataTimeSeries';
import { cn } from '../../lib/utils';

export default function AuditabilityTest({ test, identifier }) {
    const [expanded, setExpanded] = React.useState(false);

    return (
        <div
            key={identifier}
            className={cn(
                "border rounded-lg bg-white overflow-hidden",
                test.is_valid ? "border-emerald-100" : "border-red-100"
            )}
        >
            <button
                className={cn(
                    "w-full flex items-center gap-3 px-4 py-2.5 hover:bg-slate-50 transition-colors text-left",
                    test.is_valid ? "border-l-2 border-l-emerald-400" : "border-l-2 border-l-red-400"
                )}
                onClick={() => setExpanded(!expanded)}
            >
                {/* Status icon */}
                {test.is_valid ? (
                    <span className="material-symbols-outlined text-[18px] text-emerald-600 flex-shrink-0">check_circle</span>
                ) : (
                    <span className="material-symbols-outlined text-[18px] text-red-600 flex-shrink-0">cancel</span>
                )}

                {/* Test name */}
                <span className="flex-1 text-sm text-slate-700 truncate">
                    {test.name}
                </span>

                {/* Expand icon */}
                <span className={cn(
                    "material-symbols-outlined text-[18px] text-slate-400 transition-transform duration-200 flex-shrink-0",
                    expanded ? "rotate-180" : ""
                )}>expand_more</span>
            </button>

            {expanded && (
                <div className="px-4 pb-4 pt-3 border-t border-slate-100 bg-slate-50/30">
                    {/* Description */}
                    {test.description && (
                        <div className="mb-4">
                            <p className="text-xs text-slate-500 uppercase tracking-wide mb-1">Description</p>
                            <p className="text-sm text-slate-700">{test.description}</p>
                        </div>
                    )}

                    {/* Used Data */}
                    {test.used_data && test.used_data.length > 0 && (
                        <div>
                            <p className="text-xs text-slate-500 uppercase tracking-wide mb-2">Data Used</p>
                            <div className="space-y-1">
                                {test.used_data.map((data: any, index: number) => {
                                    if (data.type === 'float') {
                                        return <AuditabilityDataFloat key={index} data={data} />;
                                    }
                                    return null;
                                })}
                            </div>
                            <AuditabilityDataTimeSeries used_data={test.used_data} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
